import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function ContactUs() {
  return (
  <>
  <Navigation/>
  <section className="contact-us">
    <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <h2 className="contact-title">
                    Onko sinulla kysyttävää? Ota meihin yhteyttä!
                </h2>
                <p className="contact-text">
                    Ota meihin yhteyttä! Arvostamme palautettasi ja olemme aina valmiina auttamaan sinua. Voit jättää viestin alla olevan lomakkeen kautta, ja palaamme asiaan mahdollisimman pian.
                </p>
                <p>
                    Huomio: Emme jaa henkilökohtaisia tietojasi kolmansille osapuolille ilman suostumustasi. Tiedot käsitellään sovellettavien tietosuojalakien mukaisesti.
                </p>
            </div>
            <div className="right-col">
                <form action="">
                    <div className="input-wrapper">
                        <label for="name">
                            Nimi <span>(pakollinen)</span>
                        </label>
                        <input type="text" name="name" id="name" placeholder="Syötä nimesi" required />
                    </div>
                    <div className="input-wrapper">
                        <label for="email">
                            Sähköposti <span>(pakollinen)</span>
                        </label>
                        <input type="email" name="email" id="email" placeholder="Syötä sähköpostiosoitteesi" required />
                    </div>
                    <div className="input-wrapper">
                        <label for="comment">
                            Viesti
                        </label>
                        <textarea name="comment" id="comment" placeholder="Kirjoita viestisi tähän"></textarea>
                    </div>
                    <button type="submit">
                        Lähetä
                    </button>
                </form>
            </div>
        </div>
    </div>
</section>

    <Footer/>
  </>
  )
}

export default ContactUs